// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React, { FunctionComponent, ReactElement } from "react";
import { DefaultLayout } from "../../layouts/DefaultLayout";

/**
 * Page to display for Invalid System Time Page.
 *
 * @param {InvalidSystemTimePagePropsInterface} props - Props injected to the component.
 *
 * @return {React.ReactElement}
 */
export const InvalidSystemTimePage: FunctionComponent = (): ReactElement => {

  return (
    <DefaultLayout>
      <h6 style={{
          fontSize: "30px",
          textTransform: "uppercase",
          fontWeight: 600,
          marginTop: "3rem",
          marginBottom: "8px",
          color: "#151515"
        }}>
          Your Clock is Invalid !
      </h6>
      <p style={{
          fontSize: "20px",
          fontWeight: 400,
          marginTop: "3rem",
          marginBottom: "3rem",
          color: "#151515"
        }}>
          It looks like your computer&rsquo;s date and time is incorrect. Please validate and try again
      </p>
    </DefaultLayout>
  );
};
